import { newE2EPage } from "@stencil/core/testing";

describe("wizard-header-step", () => {
    it("renders a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<uic-wizard-header-step></uic-wizard-header-step>`);
        const el = await page.find("uic-wizard-header-step");
        expect(el).toHaveClass("hydrated");
    });

    it("renders with label, index, state and flyout", async () => {
        const page = await newE2EPage();
        await page.setContent(`
        <uic-wizard-header-step
            index="4"
            state="in-progress"
            selected
            flyout-open>
                Step Label
                <div slot="flyout-content">
                    Test
                </div>
        </uic-wizard-header-step>`);
        const el = await page.find("uic-wizard-header-step");
        await page.evaluate(async () => {
            // remove style attribute to make snapshot testing easier
            document.querySelector("uic-flyout").removeAttribute("style");
        });
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("opens the flyout when the step is selected and flyout-open is set to true", async () => {
        const page = await newE2EPage();

        await page.setContent(`<uic-wizard-header-step selected>
            <div slot="flyout-content">
                Test
            </div>
        </uic-wizard-header-step>`);

        const step = await page.find("uic-wizard-header-step");
        expect(step).not.toHaveAttribute("flyout-open");
        // eslint-disable-next-line
        await page.$eval("uic-wizard-header-step", (step: any) => {
            step.flyoutOpen = true;
        });

        await page.waitForChanges();

        expect(step).toHaveAttribute("selected");
        expect(step).toHaveAttribute("flyout-open");

        const flyout = await step.find("uic-flyout");
        expect(flyout).toHaveClass("uic-flyout--opened");
    });

    it("keeps the flyout closed when the step is not selected and flyout-open is set to true", async () => {
        const page = await newE2EPage();

        await page.setContent(`<uic-wizard-header-step>
            <div slot="flyout-content">
                Test
            </div>
        </uic-wizard-header-step>`);

        const step = await page.find("uic-wizard-header-step");
        expect(step).not.toHaveAttribute("flyout-open");
        // eslint-disable-next-line
        await page.$eval("uic-wizard-header-step", (step: any) => {
            step.flyoutOpen = true;
        });

        await page.waitForChanges();

        expect(step).not.toHaveAttribute("selected");
        expect(step).not.toHaveAttribute("flyout-open");

        const flyout = await step.find("uic-flyout");
        expect(flyout).not.toHaveClass("uic-flyout--opened");
    });

    it("opens the flyout when auto-flyout is enabled", async () => {
        const page = await newE2EPage();

        await page.setContent(`<uic-wizard-header-step>
            <div slot="flyout-content">
                Test
            </div>
        </uic-wizard-header-step>`);

        const step = await page.find("uic-wizard-header-step");
        expect(step).not.toHaveAttribute("selected");
        expect(step).not.toHaveAttribute("flyout-open");
        // eslint-disable-next-line
        await page.$eval("uic-wizard-header-step", (step: any) => {
            step.autoFlyout = true;
            step.selected = true;
        });

        await page.waitForChanges();

        expect(step).toHaveAttribute("selected");
        expect(step).toHaveAttribute("flyout-open");

        const flyout = await step.find("uic-flyout");
        expect(flyout).toHaveClass("uic-flyout--opened");
    });

    it("keeps the flyout closed when auto-flyout is disabled", async () => {
        const page = await newE2EPage();

        await page.setContent(`<uic-wizard-header-step>
            <div slot="flyout-content">
                Test
            </div>
        </uic-wizard-header-step>`);

        const step = await page.find("uic-wizard-header-step");
        expect(step).not.toHaveAttribute("selected");
        expect(step).not.toHaveAttribute("flyout-open");
        // eslint-disable-next-line
        await page.$eval("uic-wizard-header-step", (step: any) => {
            step.selected = true;
        });

        await page.waitForChanges();

        expect(step).toHaveAttribute("selected");
        expect(step).not.toHaveAttribute("flyout-open");

        const flyout = await step.find("uic-flyout");
        expect(flyout).not.toHaveClass("uic-flyout--opened");
    });

    it("emits selection request when clicking on the step", async () => {
        const page = await newE2EPage();

        await page.setContent(`<uic-wizard-header-step>
            Label
            <div slot="flyout-content">
                Test
            </div>
        </uic-wizard-header-step>`);

        const step = await page.find("uic-wizard-header-step");
        const uicWizardStepSelect = await step.spyOnEvent("uicWizardStepSelect");

        await step.click();

        await page.waitForChanges();

        expect(uicWizardStepSelect).toHaveReceivedEventTimes(1);

        const flyout = await step.find("uic-flyout");
        expect(flyout).not.toHaveClass("uic-flyout--opened");
    });

    it("emits selection request when calling select()", async () => {
        const page = await newE2EPage();

        await page.setContent(`<uic-wizard-header-step>Label
            <div slot="flyout-content">
                Test
            </div>
        </uic-wizard-header-step>`);

        const step = await page.find("uic-wizard-header-step");
        const uicWizardStepSelect = await step.spyOnEvent("uicWizardStepSelect");
        // eslint-disable-next-line
        await page.$eval("uic-wizard-header-step", (step: any) => {
            step.select();
        });

        await page.waitForChanges();

        expect(uicWizardStepSelect).toHaveReceivedEventTimes(1);

        const flyout = await step.find("uic-flyout");
        expect(flyout).not.toHaveClass("uic-flyout--opened");
    });

    it("opens the flyout when clicking on the step while selected", async () => {
        const page = await newE2EPage();

        await page.setContent(`<uic-wizard-header-step selected>
            <div slot="flyout-content">
                Test
            </div>
        </uic-wizard-header-step>`);

        const step = await page.find("uic-wizard-header-step");
        expect(step).toHaveAttribute("selected");
        expect(step).not.toHaveAttribute("flyout-open");

        await page.click("uic-wizard-header-step");

        await page.waitForChanges();

        expect(step).toHaveAttribute("selected");
        expect(step).toHaveAttribute("flyout-open");

        const flyout = await step.find("uic-flyout");
        expect(flyout).toHaveClass("uic-flyout--opened");
    });

    it("closes the opened flyout when clicking on the step while selected", async () => {
        const page = await newE2EPage();

        await page.setContent(`<uic-wizard-header-step selected>
            <div slot="flyout-content">
                Test
            </div>
        </uic-wizard-header-step>`);

        const step = await page.find("uic-wizard-header-step");
        expect(step).toHaveAttribute("selected");

        // eslint-disable-next-line
        await page.$eval("uic-wizard-header-step", (step: any) => {
            step.flyoutOpen = true;
        });
        await page.waitForChanges();

        expect(step).toHaveAttribute("flyout-open");

        await page.click("uic-wizard-header-step");

        await page.waitForChanges();

        expect(step).toHaveAttribute("selected");
        expect(step).not.toHaveAttribute("flyout-open");

        const flyout = await step.find("uic-flyout");
        expect(flyout).not.toHaveClass("uic-flyout--opened");
    });

    it("aligns the flyout in the center when wider than the flyout width", async () => {
        const page = await newE2EPage();

        await page.setContent(`<uic-wizard-header-step selected flyout-open style="width: 500px">
            <div slot="flyout-content">
                Test
            </div>
        </uic-wizard-header-step>`);

        const step = await page.find("uic-wizard-header-step");
        expect(step).toHaveAttribute("selected");
        expect(step).toHaveAttribute("flyout-open");

        const flyout = await step.find("uic-flyout");

        await page.waitForChanges();

        expect(flyout).toEqualAttribute("data-popper-placement", "bottom");
    });

    it("algins the flyout to the right when smaller than the flyout width", async () => {
        const page = await newE2EPage();

        await page.setContent(`<uic-wizard-header-step selected flyout-open style="width: 100px">
            <div slot="flyout-content">
                Test
            </div>
        </uic-wizard-header-step>`);

        const step = await page.find("uic-wizard-header-step");
        expect(step).toHaveAttribute("selected");
        expect(step).toHaveAttribute("flyout-open");

        const flyout = await step.find("uic-flyout");
        expect(flyout).toEqualAttribute("data-popper-placement", "bottom-end");
    });

    it("toggles the flyout when calling toggleFlyout() while selected", async () => {
        const page = await newE2EPage();

        await page.setContent(`<uic-wizard-header-step selected>
            Label
            <div slot="flyout-content">
                Test
            </div>
        </uic-wizard-header-step>`);

        const step = await page.find("uic-wizard-header-step");
        const uicWizardStepSelect = await step.spyOnEvent("uicWizardStepSelect");
        // eslint-disable-next-line
        await page.$eval("uic-wizard-header-step", (step: any) => {
            step.toggleFlyout();
        });

        await page.waitForChanges();

        expect(uicWizardStepSelect).toHaveReceivedEventTimes(0);

        const flyout = await step.find("uic-flyout");
        expect(flyout).toHaveClass("uic-flyout--opened");
        // eslint-disable-next-line
        await page.$eval("uic-wizard-header-step", (step: any) => {
            step.toggleFlyout();
        });

        await page.waitForChanges();

        expect(flyout).not.toHaveClass("uic-flyout--opened");
    });
});
